import React from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';


const Index = (props) => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
      disableSort: true
    },
  ]

  return <ListingPageComponent
    key={PAGES.LeadsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.LeadsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Leads'}]}
    listingMutation={getApi('leads')}
    className="leads-listing-page"
    contentHeading="Leads List - Results"
    headers={headers}
    recordsKey="leads"
    searchBy={['ID', 'Name']}
  />

}

export default Index;
